import React, { useEffect } from "react";

import getContentById from "../../../../shared/utils/getContentById";
import _ from "lodash";
import Backgrounds from "../../_partials/Backgrounds/Index";
import TemplateBlock from "../../_partials/TemplateBlock/Index";
import prepareVideoBg from "../../../../shared/functions/prepareVideoBg";

import animationScript, { animationCleanUp } from "./animation.js";
import assets from "./assets";
import getOptaCountryCode from "../../../../shared/utils/getOptaCountryCode";
import { getPlayerStats } from "../../../../shared/utils/opta/statsHandler";
// import outroVideo9x16 from "../../../assets/outros/outro_playoffs_9x16.webm";

require("./style/style.scss");
require("./style/animation.scss");

import {
  positionTranslations,
  positionExtension,
} from "../../../../shared/utils/opta/player";
import { useTranslation } from "react-i18next";
import { getPlayerPosition } from "../../../../shared/utils/players";
import Image from "../../../../shared/components/Image";
import BildTeamLogo from '../../../../shared/components/Image/BildTeamLogo';
import BildPlayerImage from '../../../../shared/components/Image/BildPlayerImage';
import { getPlayerShorLastName, getShortPlayerName } from "../../../../shared/feeds/worldcup/playerHelper";
import { WcBgCircle } from "../../../../shared/backgrounds/WcBgCircle/Index";
import { PlayerTriko } from "../../_partials/PlayerTriko/Index";
import ProgressBar from "../../../../shared/components/ProgressBar";
import { MatchScoreWidget } from "../../_partials/MatchScoreWidget/MatchScoreWidgetForBild.jsx";
import PlayerImage from "../../../../shared/components/Image/PlayerImage.jsx";
import { getDynamicLogoPath } from "../../../../shared/utils/functions.js";

const Index = (props) => {
  const refs = {
    player: React.createRef(),
    team: React.createRef(),
  };

  const {
    animation,
    data,
    images: Images,
    apiSetup,
    mode,
    format,
    isTimeline,
  } = props;

  const id = `${_.get(data, "template_name", "")}_${_.get(data, "uuid", "")}`;
  const { t } = useTranslation();

  const prepareAnimation = () => {
    prepareVideoBg({ id });
  };

  useEffect(() => {
    let animationReturn = null;
    if (mode === "animation" || mode === "video") {
      if (animation) {
        prepareAnimation();
        animationReturn = animationScript({
          refs,
          data,
          animation,
          mode,
          id,
          format,
          apiSetup,
          templateName: data?.template_name
        });
      }
    }

    //handle outro video BEGIN
    // if(mode === "video" && !isTimeline) {
    //   const outroVideo = $(`#${id} video.outro-optional-video`);
    //   outroVideo.get(0).addEventListener("loadedmetadata", function() {
    //       const that = this;
    //       setTimeout(()=> {
    //         outroVideo?.css('opacity', 1);
    //         this.currentTime = 0;
    //         that.play();
    //       }, frontendCfg.showOutroAfter)
    //     }, false);
    // }
    //handle outro video END

    return function cleanUp() {
      if (animationReturn) {
        animationCleanUp(animationReturn);
      }
    };
  }, [animation, mode]);

  const templateData = _.get(data, "data");

  const { dynamic } = templateData;

  const winningTeamSide = _.get(dynamic, "winningTeamSide");
  const mvp = _.get(dynamic, "mvp");
  const matchInfo = _.get(dynamic, "matchInfo");
  const homeTeam = matchInfo?.home;
  const awayTeam = matchInfo?.away;
  const playerHome = mvp?.mvp;
  const team = winningTeamSide === "home" ? homeTeam : awayTeam;
  return (
    <div
      id={id}
      className={`T_${_.get(data, "template_name", "")} ${animation ? "animation" : ""} side-${_.get(dynamic, "teamSide")}`}
    >
      <TemplateBlock class={`${isTimeline ? "" : "template-bild"}`}>
        {
          !isTimeline && <div className="main-header-content">
            <div className="main-header">
              {t("MVPHeadline", { keyPrefix: "templates" })}
            </div>
            <MatchScoreWidget
              homeTeam={homeTeam}
              awayTeam={awayTeam}
              matchInfo={matchInfo}
            />
          </div>
        }
        <div className={"wc-content wc-content-v2"}>
          <ProgressBar height={"8px"} />

          <div className="main-content-side">
            <div className={"left-block-side"}>
              <BildPlayerImage className="player-avatar" id={playerHome?.playerId} />
              <div className="left-block-shadow"></div>
            </div>

            <div className={"center-block-side"}>
              <div className="center-row">
                <div className="item-type">
                  <div className={"team-logo-container home"}>
                    <BildTeamLogo
                      className="team-logo"
                      id={team?.id}
                    />
                  </div>
                </div>
                <div className="item-content content-bold player-name">
                  {playerHome?.person?.surname}
                </div>
              </div>

              <div className="center-row item-goal">
                <div className="item-type">
                  {playerHome?.score}
                </div>
                <div className="item-content">
                  {t("Goals", { keyPrefix: "templates" })}
                </div>
              </div>

              <div className="center-row item-assist">
                <div className="item-type">
                  {playerHome?.assists}
                </div>
                <div className="item-content">
                  {t("total assists", { keyPrefix: "rankingLabels" })}
                </div>
              </div>

              <div className="center-row item-duel">
                <div className="item-type">
                  {playerHome?.duels_won_percentage} %
                </div>
                <div className="item-content">
                  {t("duelWon", { keyPrefix: "stats" })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </TemplateBlock>
    </div>
  );
};

const getMainBackground = (format, side) => {
  return _.get(assets, `background_1920`);
};

export default Index;
